import React, { useState, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Image,
  Dropdown
} from 'react-bootstrap';
import { store } from 'react-notifications-component';
import Backend from "../../../Backend";
import Connection from "../../../Calls";
import SelectCoins from '../../../Components/Select/SelectCoins';
import ModalWallets from "../../Modal/ModalWallet";
import "./ExchangeComponent.css";
import ArrowIcon from "../../../Images/arrow-down.png";
import ModalConfirm from "../ModalConfirmOrder/ModalConfirmOrder";
import ModalContract from "../Contract/modalContract";

function formatMoney(n, c, d, t) {
  var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

const ExchangeComponent = (props) => {
  const [radioValue, setRadioValue] = useState('0');
  const [amount, setAmount] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [prices, setPrices] = useState("");
  const [vexFee, setVexFee] = useState("");
  const [disabledConfirm, setDisabledConfirm] = useState(false);
  const [format, setFormat] = useState(false)
  const [coinExchange, setCoinExchange] = useState('');
  const [coinTo, setCoinTo] = useState('');
  const [walletExchange, setWalletExchange] = useState("");
  const [walletExchangeTo, setWalletExchangeTo] = useState("");
  const [filterOptions, setFilterOptions] = useState([])
  const [filterWallets, setFilterWallets] = useState([]);
  const [filterWalletsTo, setFilterWalletsTo] = useState([]);
  const [modalContract, setModalContract] = useState(false)

  const closeModal = () => setShow(false);
  const closeModalConfirm = () => setShowModal(false);

  const calculatedFee = useMemo(()=>{
    let total = 0
    let fixedNum = 8
    if(coinExchange == 'mxn' || coinExchange == 'vusd') fixedNum = 2
    return total = (amount * (vexFee/100)).toFixed(fixedNum)
  }, [amount,vexFee])

  useEffect(()=>{
  },[])

  useEffect(() => {
    if (coinExchange?.symbol !== 'usd' && coinExchange?.symbol !== 'vmxn' && walletExchange){
      if(radioValue !== '0'){
        getWalletBalance(walletExchange, "1", coinExchange)
      }
    } else {
      getWalletBalance(walletExchangeTo, "2", coinExchange)
    }
    if (props.planInfo != null){
      setVexFee(props.planInfo.transaction_xchV_fee)
    }
  }, [walletExchangeTo, coinTo, coinExchange, radioValue]);

  useEffect(()=>{
    setRadioValue('0')
    setAmount('')
  },[walletExchange])

  const getWalletBalance = (param, intrumen, coin) => {
    if (param !== "" && param !== "0"){
      if (intrumen === "1"){
        setAmount(((Number(radioValue) * param.balance) / 100).toFixed(8))
      } else {
        setAmount(( (Number(radioValue) * param.balance_usd) / 100).toFixed(8))
      }
    }

    if (coin?.symbol === 'vmxn' ){
      let balance_mxn = props.balance.balance_virtual_mxn;
      setAmount(((Number(radioValue) * balance_mxn) / 100).toFixed(8))
    } else if (coin?.symbol === 'usd' ){
      let balance_usd = props.balance.balance_virtual;
      setAmount(((Number(radioValue) * balance_usd) / 100).toFixed(8))
    }
  }

  const filterCoins = (coinSelect) => {
    if (coinSelect === 'usdt'){
      return props.coins.filter(coin => coin.symbol !== "usdt" && coin.symbol !== 'tdc')
    } else if(coinSelect === 'tdc'){
      return props.coins.filter(coin => coin.symbol !== "vmxn" && coin.symbol !== "usd" && coin.symbol !== "tdc")
    } else if (coinSelect !== "vmxn" && coinSelect !== "usd" && coinSelect !== "usdt"){
      return props.coins.filter(coin => coin.symbol === "vmxn" || coin.symbol === "usd" || coinSelect !== coin.symbol && coin.symbol !== "usdt" && coin.symbol !== "tdc")
    } else if(coinSelect === "vmxn" || coinSelect === "usd"){
      return props.coins.filter(coin => coin.symbol !== "vmxn" && coin.symbol !== "usd" && coin.symbol !== "usdt" && coin.symbol !== "tdc")
    }
  }

  const filtWallets = (coinSelect) => {
    if (props && props.wallets?.length > 0 && coinSelect !== "vmxn" || coinSelect !== "usd") {
      return props.wallets.filter(wallet => wallet.coin === coinSelect)
    }
  }

  useEffect(()=> {
    if (coinExchange !== undefined){
      setFilterOptions(filterCoins(coinExchange.symbol))
      filtWallets(coinExchange.symbol)
    }
    if(coinExchange?.symbol === coinTo?.symbol){
      setCoinTo("")
    }

    if(coinTo?.symbol === 'vmxn' || coinTo?.symbol === 'usd'){
      if(coinExchange?.symbol === 'tdc'){
        setCoinTo("")
      }
    }

  }, [coinExchange, walletExchangeTo, walletExchange, coinTo])

  useEffect(() => {
    if(coinExchange !== undefined){
      if(coinExchange && coinExchange.symbol === "vmxn" || coinExchange.symbol === "usd") {
        setCoinTo("")
      }
      setFilterWallets(filtWallets(coinExchange.symbol))
    }
  },[coinExchange, props.wallets.length, walletExchange]);

  useEffect(() => {
    setFilterWalletsTo(filtWallets(coinTo?.symbol))
    if(coinTo !== ''){
      // filtWallets(coinTo)
    }
  },[props.wallets.length, coinTo, walletExchangeTo]);

  const handleExchange = (e) => {
    setCoinExchange(e)
    if (e.symbol === 'vmxn' || e.symbol === 'usd' || e.symbol === 'tdc') {
      setWalletExchange("0");
    } else {
      setWalletExchange("")
    }
  }

  const secundarySelect = (e) => {
    setCoinTo(e)
    if (e.symbol === 'vmxn' || e.symbol === 'usd') {
      setWalletExchangeTo("0");
    } else {
      setWalletExchangeTo("")
    }
  }

  const handleCreateOrderExchange = () => {

    const {contractStatus} = props;

    // REMOVE
    if (coinExchange.symbol === 'tdc' && contractStatus !== 'pending') {
      return setModalContract(true)
    }

    if (coinExchange.symbol === 'tdc' && contractStatus === 'pending'){
      return getUrlCheckout()
    }

    // if (coinExchange.symbol === 'tdc' && contractStatus === 'pending') {
    //   return setModalContract(true)
    // }

    // if (coinExchange.symbol === 'tdc' && contractStatus !== 'pending'){
    //   return getUrlCheckout()
    // }

    setDisabledConfirm(true);
    let exchangeSymbol = (coinExchange.symbol == 'vmxn' || coinExchange.symbol === 'tdc') ? 'mxn' : coinExchange.symbol
    let toSymbol = (coinTo.symbol === 'vmxn') ? 'mxn' : coinTo.symbol

    let wallet_from =  walletExchange?.id_wallet ? walletExchange.id_wallet : walletExchange
    let wallet_to = walletExchangeTo?.id_wallet ? walletExchangeTo.id_wallet : walletExchangeTo

    if(amount && amount !== "" && exchangeSymbol && exchangeSymbol !== "" && toSymbol && toSymbol !== "" && wallet_from && wallet_from !== "" && wallet_to && wallet_to !== "") {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.CreateOrderVirtualExchange2(localStorage.getItem('email'), localStorage.getItem('token'), exchangeSymbol, toSymbol, wallet_from, wallet_to, amount, response.payload.r01, response => {
          if(response.status.code === "0") {
            setTimeout(() => {
              setDisabledConfirm(false);
            }, 2000);
            closeModalConfirm();
            store.addNotification({
              title: "Success",
              message: "Order exchange",
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            })
            setAmount("")
            setCoinExchange('');
            setCoinTo()
            setWalletExchange("");
            setWalletExchangeTo("")
            props.handleVexOrderCreated(response)
          } else {
            closeModalConfirm();
            setTimeout(() => {
              setDisabledConfirm(false);
            }, 2000);
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            })
          }
        })
      })
    } else {
      setDisabledConfirm(false);
      store.addNotification({
        title: "Error!",
        message: "Fields empty or invalid",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      })
    }
  }

  // RENDER PRICES SOCKET
  useEffect(() => {
    let symbolMXN = 'MXN';
    let hight_value;

    if(coinExchange?.symbol === "usd" && coinTo !== '' && coinTo?.symbol !== 'sol'){
      setPrices(props.prices[coinTo?.symbol?.toUpperCase()]?.ask)
      setFormat(true)
    } else if (coinExchange?.symbol === "vmxn" && coinTo !== ''){
      setPrices(props.prices[coinTo?.symbol?.toLocaleUpperCase()+symbolMXN]?.ask)
      setFormat(true)
    } else if (coinTo?.symbol === "usd" && coinExchange !== '' && coinExchange?.symbol !== 'sol' && coinExchange?.symbol !== 'usdt'){
      setPrices(props.prices[coinExchange?.symbol?.toUpperCase()]?.bid)
      setFormat(true)
    } else if (coinTo?.symbol === "vmxn" && coinExchange !== '' && coinExchange?.symbol !== 'sol' && coinExchange?.symbol !== 'usdt'){
      setPrices(props.prices[coinExchange?.symbol?.toUpperCase()+symbolMXN]?.bid)
      setFormat(true)
    } else if (coinExchange?.symbol === 'usd' && coinTo?.symbol === "sol"){
      setPrices(props.prices[coinTo?.symbol?.toUpperCase()]?.ask)
      setFormat(true)
    } else if (coinTo?.symbol === "sol" && coinExchange !== '' && coinExchange?.symbol === 'vmxn'){
      setPrices(props.prices[coinTo?.symbol?.toUpperCase()+symbolMXN]?.ask)
      setFormat(true)
    } else if (coinExchange?.symbol === 'sol' && coinTo?.symbol === "usd"){
      setPrices(props.prices[coinExchange?.symbol?.toUpperCase()]?.bid)
      setFormat(true)
    } else if (coinExchange?.symbol === 'sol' && coinTo?.symbol === "vmxn"){
      setPrices(props.prices[coinExchange?.symbol?.toUpperCase()+symbolMXN]?.bid)
      setFormat(true)
    } else if (coinExchange?.symbol === 'usdt' && coinTo?.symbol === "usd"){
      setPrices(1)
      setFormat(true)
    } else if (coinExchange?.symbol === 'usdt' && coinTo?.symbol === "vmxn" || coinExchange?.symbol === 'tdc' && coinTo?.symbol === "usdt"){
      setPrices(props.prices['USDMXN']?.bid)
      setFormat(true)
    } else if (coinExchange?.symbol === 'usdt' && coinTo?.symbol !== "vmxn" && coinTo?.symbol !== 'usd' && coinTo?.symbol !== 'sol'){
      let bid = props.prices[coinTo?.symbol?.toUpperCase()]?.bid
      let ask = props.prices[coinTo?.symbol?.toUpperCase()]?.ask
      hight_value = Math.max(bid,ask)
      setPrices(hight_value)
      setFormat(false)
    } else if (coinExchange?.symbol === 'usdt' && coinTo?.symbol ==='sol'){
      let bid = props.prices[coinTo?.symbol?.toUpperCase()]?.bid
      let ask = props.prices[coinTo?.symbol?.toUpperCase()]?.ask
      hight_value = Math.max(bid,ask)
      setPrices(hight_value)
      setFormat(false)
    } else if (coinExchange?.symbol !== 'usdt' && coinExchange?.symbol !== 'vmxn' && coinExchange?.symbol !== 'usd' && coinTo?.symbol !== "usd" && coinTo?.symbol !== 'vmxn'){
      if(coinExchange?.symbol === 'tdc'){
        let bid = props.prices[coinTo?.symbol?.toUpperCase()+'MXN']?.bid
        let ask = props.prices[coinTo?.symbol?.toUpperCase()+'MXN']?.ask
        hight_value = Math.max(bid,ask)
        setPrices(hight_value)
        setFormat(false)
      } else {
        console.log(coinExchange?.symbol?.toUpperCase()+coinTo?.symbol?.toUpperCase());
        let bid = props.prices[coinExchange?.symbol?.toUpperCase()+coinTo?.symbol?.toUpperCase()]?.bid
        let ask = props.prices[coinExchange?.symbol?.toUpperCase()+coinTo?.symbol?.toUpperCase()]?.ask
        console.log(String(bid)+" "+String(ask));
        hight_value = Math.max(bid,ask)
        setPrices(hight_value)
        setFormat(false)
      }
    }
  },[coinTo, props.prices])

  const CryptoYouGet = () => {
    let youGet = 0;
    if(amount !== "" && coinExchange !==''){
      if(coinExchange?.symbol === 'vmxn'){
        youGet = (1/prices) * Number(amount)
      } else if (coinTo?.symbol === 'vmxn'){
        youGet = prices * Number(amount)
      } else if (coinExchange?.symbol === 'usd' || coinExchange?.symbol === 'usdt'){
        youGet = (1/prices) * Number(amount)
      } else if (coinTo?.symbol ==='usd'){
        youGet = prices * Number(amount)
      } else if(coinExchange?.symbol === 'tdc'){
        youGet = (1/prices) * Number(amount)
      }else {
        youGet = prices * Number(amount)
      }
    }
    return Number(youGet).toFixed(8)
  }
  const handleWalletCreated = (response) => {
    props.handleWalletCreated(response)
  }

  const getUrlCheckout = () => {
    setDisabledConfirm(true)
    let wallet_to = walletExchangeTo?.id_wallet ? walletExchangeTo.id_wallet : walletExchangeTo
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.confirmBuyCryptoCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, amount, wallet_to, coinTo.symbol, response => {
        if (response.status.code === '0'){
          setDisabledConfirm(false)
          const {url} = response.payload
          setShowModal(false)
          window.open(url, '_blank');
          setAmount("")
          setCoinExchange('');
          setCoinTo()
          setWalletExchange("");
          setWalletExchangeTo("")
        } else {
          setDisabledConfirm(false)
        }
      })
    })
  }

  return(
    <>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '15px'}}>
        <span className="font-medium font-size-20">{props.traductions.VEX.titleEX}</span>
      </div>
      <div className="card-wallet">
        <Row>
          <Col xl={12}>
            <Row>
              <Col xl={6}>
                <Form.Label className="label-exchange">{props.traductions.VEX.intrument_exchange}</Form.Label>
                <SelectCoins
                  value={coinExchange}
                  options={props.coins}
                  onChange={handleExchange}
                  placeholder={props.traductions.VEX.placeholder_coin}
                />
                {coinExchange.symbol === 'tdc' &&
                  <span style={{color: '#8E95AB', fontSize: 12}}>Pagos con VISA y Mastercard empleando 3D Secure.</span>
                }
              </Col>
              <Col xl={6}>
                {
                  coinExchange && coinExchange.symbol !== "vmxn" && coinExchange.symbol !== "usd" && coinExchange.symbol !== "tdc" &&
                  <>
                    <div className='virtual_exchange_dropdown'>
                      <Form.Label style={{marginBottom:4}} className="virtual_exchange_information_wallets_text"> {props.traductions.wallets.Index.modalTransfers.L_FromWallets}:</Form.Label>
                      <Dropdown title={(walletExchange)?walletExchange.alias:props.traductions.wallets.Index.modalTransfers.S_Wallets}>
                        <Dropdown.Toggle id="dropdown-custom-1">
                          {
                            (walletExchange)
                            ?
                            <>
                              {
                                walletExchange && walletExchange.coin &&
                                <Image src={require("../../../CryptoIcons/" + walletExchange.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                              }
                              {walletExchange.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(walletExchange.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{walletExchange.coin}</label>
                            </>
                            :props.traductions.wallets.Index.modalTransfers.S_Wallets
                          }
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {
                            filterWallets && filterWallets.length > 0 && filterWallets.map((wallet, index)=> (
                              <Dropdown.Item onClick={()=>setWalletExchange(wallet)} as="button">
                                {
                                  wallet && wallet.coin &&
                                  <Image src={require("../../../CryptoIcons/" + wallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                                }
                                {wallet.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(wallet.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{wallet.coin}</label>
                              </Dropdown.Item>
                            ))
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                      {
                        filterWallets && filterWallets.length === 0 &&
                        <a className="add-wallet" onClick={() => setShow(true)}>{props.traductions.VEX.emptyWallet}</a>
                      }
                    </div>
                  </>
                }
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Col xl={12} className="arrow-icon-position">
        <div><Image src={ArrowIcon} width={50}/></div>
      </Col>
      <div className="card-wallet" style={{marginTop: "15px"}}>
        <Row>
          <Col xl={12}>
            <Row>
              <Col xl={6}>
                <Form.Label className="label-exchange">{props.traductions.VEX.intrument_get}</Form.Label>
                <SelectCoins
                  value={coinTo}
                  options={filterOptions}
                  onChange={secundarySelect}
                  placeholder={props.traductions.VEX.placeholder_coin}
                />
              </Col>
              <Col xl={6}>
                {
                  coinTo && coinTo?.symbol !== "usd" && coinTo?.symbol !== "vmxn" &&
                  <>
                    <div className='virtual_exchange_dropdown'>
                      <Form.Label style={{margin:2}} className="virtual_exchange_information_wallets_text"> {props.traductions.wallets.Index.modalTransfers.L_ToWallets}</Form.Label>
                      <Dropdown title={(walletExchangeTo)?walletExchangeTo.alias:props.traductions.wallets.Index.modalTransfers.S_Wallets}>
                        <Dropdown.Toggle id="dropdown-custom-1">
                          {
                            (walletExchangeTo)
                            ?
                            <>
                              {
                                walletExchangeTo && walletExchangeTo.coin &&
                                <Image src={require("../../../CryptoIcons/" + walletExchangeTo.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                              }
                              {walletExchangeTo.alias}: <label key={walletExchangeTo.alias} style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(walletExchangeTo.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{walletExchangeTo.coin}</label>
                            </>
                            :props.traductions.wallets.Index.modalTransfers.S_Wallets
                          }
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {
                            filterWalletsTo && filterWalletsTo.length > 0 && filterWalletsTo.map((wallet, index)=> (
                              <Dropdown.Item onClick={()=>setWalletExchangeTo(wallet)} as="button">
                                {
                                  wallet && wallet.coin &&
                                  <Image src={require("../../../CryptoIcons/" + wallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                                }
                                {wallet.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(wallet.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{wallet.coin}</label>
                              </Dropdown.Item>
                            ))
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                      {
                        coinTo && coinTo.symbol !== 'selected' && filterWalletsTo && filterWalletsTo.length === 0 &&
                        <a className="add-wallet" onClick={() => setShow(true)}>{props.traductions.VEX.emptyWallet}</a>
                      }
                    </div>
                  </>
                }
              </Col>
            </Row>
        </Col>
      </Row>
    </div>
    <div className="card-amount" style={{marginTop: "15px"}}>
      <span className="font-medium font-size-16">{props.traductions.VEX.L_Amount}</span>
        <Row>
          <Col xl={6}>
            <InputGroup className="mb-3">
              <Form.Control
                className="amount-input"
                placeholder="0.00"
                type="number"
                aria-describedby="basic-addon2"
                id="amount"
                onKeyDown={ (evt) => evt.key === 'e' && evt.preventDefault() }
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
              />
              {
                coinExchange !== '' &&
                <InputGroup.Text id="basic-addon2">{coinExchange?.symbol === 'tdc' ? 'MXN' : coinExchange?.symbol?.toUpperCase()}</InputGroup.Text>
              }
            </InputGroup>
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: coinExchange?.symbol !== 'tdc' ? '10px': '65px'}}>
            {
              coinExchange?.symbol !== 'tdc' &&
              <>
              <Button onClick={() => setRadioValue('25')} className={radioValue === "25" ? "btn-control-active": "btn-control"}>25%</Button>
              <Button onClick={() => setRadioValue('50')} className={radioValue === "50" ? "btn-control-active": "btn-control"}>50%</Button>
              <Button onClick={() => setRadioValue('75')} className={radioValue === "75" ? "btn-control-active": "btn-control"}>75%</Button>
              <Button onClick={() => setRadioValue('100')} className={radioValue === "100" ? "btn-control-active": "btn-control"}>100%</Button>
              </>
            }
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'flex-end', marginTop: '30px'}}>
              <span className="fees-label">{props.traductions.VEX.Fee}</span>
              <div className="fees-estimated--container">
                <span className="crypt-fee--label">{(coinExchange?.symbol == "vmxn" || coinExchange?.symbol == "usd" || coinExchange?.symbol == "tdc")? formatMoney(calculatedFee): isNaN(calculatedFee) ? "" : calculatedFee} {coinExchange?.symbol === 'tdc' ? "MXN" : coinExchange?.symbol?.toUpperCase()}</span>
                <span id="estimatedLabel" className="virtual-fee--label">
                  {(coinTo?.symbol === "vmxn" || coinTo?.symbol === "usd") ? `(${props.traductions.VEX.L_estimated} ${formatMoney((calculatedFee * prices) / 1)} ${coinTo?.symbol?.toUpperCase()})` : ""}
                </span>
              </div>
            </div>
          </Col>
          <Col xl={6}>
            <Row>
              <Col xl={5}>
                <span className="font-regular font-size-12">{props.traductions.VEX.market_price}</span>
              </Col>
              <Col xl={7} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <span className="font-regular font-size-14">{ coinExchange?.symbol !=='tdc' ? coinExchange?.symbol?.toUpperCase() : "MXN"}/{coinTo?.symbol?.toUpperCase()}
                  <span>{' '}
                  {prices ? format ? formatMoney(prices) : prices : ""}
                  </span>
                </span>
              </Col>
            </Row>
            <Row style={{marginTop: '30px'}}>
              <Col xl={2}>
                <span style={{color: '#1F45FF'}} className="font-regular font-size-12">{props.traductions.VEX.get}</span>
              </Col>
              <Col xl={10} style={{display: 'flex', justifyContent: 'flex-end'}}>
                <span style={{color: '#1F45FF', display: 'flex', alignItems: 'center'}} className="font-regular font-size-14">
                  { coinTo && coinTo?.symbol ?
                    <Image style={{marginRight: '5px'}} width={15} src={require('../../../CryptoIcons/' + coinTo?.symbol + '.svg')}/>
                    : null
                  }
                  {(coinTo?.symbol == "vmxn" || coinTo?.symbol == "usd")?formatMoney(CryptoYouGet()):CryptoYouGet()} {coinTo?.symbol?.toUpperCase()}</span>
              </Col>
            </Row>
            <Row style={{marginTop: '30px'}}>
              <Col xl={12}>
                <Button
                  // disabled={coinTo === '' || coinExchange === '' || walletExchange === '' || walletExchangeTo === '' || amount === '' || coinExchange?.symbol === 'tdc' && !props.cryptoStatus}
                  disabled={coinTo === '' || coinExchange === '' || walletExchange === '' || walletExchangeTo === '' || amount === ''}
                  onClick={() => setShowModal(true)}
                  style={{width: '100%', backgroundColor: '#1F45FF'}}
                >
                  {props.traductions.VEX.titleEX}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      {
        showModal &&
        <ModalConfirm
          showModal={showModal}
          coinExchange={coinExchange}
          coinTo={coinTo}
          onHide={closeModalConfirm}
          walletExchange={walletExchange}
          walletExchangeTo={walletExchangeTo}
          confirm={handleCreateOrderExchange}
          disabled={disabledConfirm}
          cryptoGet={CryptoYouGet()}
          fee={calculatedFee}
          amount={amount}
          prices={prices}
          traductions={props.traductions}
        />
      }
      {
        modalContract &&
        <ModalContract
          show={modalContract}
          onHide={setModalContract}
          setShowModal={setShowModal}
          getUrlCheckout={getUrlCheckout}
        />
      }
      <ModalWallets
        {...props}
        coins={props.coins}
        coinsInfo={props.coinsInfo}
        planInfo={props.planInfo}
        wallets={props.wallets}
        handleWalletCreated={handleWalletCreated}
        title="Add Wallet"
        show={show}
        onHide={closeModal}
      />
    </>
  )
}

export default ExchangeComponent
